import { render, staticRenderFns } from "./CreatePhaseStatusVerticalStep3.vue?vue&type=template&id=8d062d0e&"
import script from "./CreatePhaseStatusVerticalStep3.vue?vue&type=script&lang=ts&"
export * from "./CreatePhaseStatusVerticalStep3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports